
import { defineComponent, ref, reactive, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { errManager, showNotification } from "@/core/config/Tools";
import { useStore } from "vuex";
//services
import GlobalService from '@/core/services/GlobalService';
import { useI18n } from "vue-i18n/index";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import DialogEditItemDetail from './DialogEditItemDetail.vue';

export default defineComponent({
    props:{
        itemOrder: {
            type: null,
            required: false,
            default: () => ({})
        },
        itemsDetails: {
            type: null,
            required: false,
            default: []
        },
        otherData: {
            type: null,
            required: false,
            default: {}
        }
    },
    components: {DialogEditItemDetail},
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const form = reactive<any>({
            mstatus: {}
        });
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});
        const DialogEditItemDetailRef = ref<any>(null);
        const itemDetails = ref<any>(null);
        //const listComprobantes = ref<any[]>([]);
        //const listPaymentMethods = ref<any[]>([]);
        //const listPaymentCurrencies = ref<any[]>([]);
        const listDetails = ref<any[]>([]);

        const userAccount = computed(() => {
            return store.getters.currentUser?.account
        });

        const listComprobantes: any = computed<any>(() => {
            return store.getters.currentUser.type_comprobante;
        });

        const listPaymentMethods: any = computed<any>(() => {
            return store.getters.currentUser.method_payment;
        });

        const listPaymentCurrencies: any = computed<any>(() => {
            return store.getters.currentUser.type_currency;
        });

        const listStatus = computed(() => {
            return store.getters.currentUser.status_pagos
        })

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            const hasData = props.itemOrder && Object.keys(props.itemOrder).length > 0;
            titleDialog.value = hasData ? t('edit'): t('register')
            if (hasData) {
                getOrder();
            } else {
                //nueva orden
                /**
                 *           idorder: "1",
                    iddetails: "1",
                 */
                form.customer = props.otherData?.customer;

                console.table(props.itemsDetails);

                const details = props.itemsDetails.map((item) => ({
                    idcompany: "1",
                    idregister: item.idacreditation,
                    desc1: item.firstname + ' ' + item.lastname + ' ' + item.surname + ' - '+ item.sport,
                    desc2: item.function_name,
                    desc3: item.titlefide,
                    price: item.elofide,
                    quantity: "1",
                    import: item.elofide,
                    type_sale: "1",
                    mstatus: "1",
                }));
                // asignar al formulario
                listDetails.value = details;
                Object.assign(form, { details: listDetails.value })
            }
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const getOrder = () => {
            loading.value = true;
            GlobalService.get('api/orders', `${props.itemOrder?.idorder}/show`)
            .then((res) => {
                Object.assign(form, { ...res.data })
                getOrderDetails();
            }).catch(({ response }) => {
                errManager(response);
            }).finally(() => {
                loading.value = false;
            });
        };

        const getOrderDetails = () => {
            loading.value = true;
            GlobalService.get('api/orders', `${props.itemOrder?.idorder}/details`)
            .then((res) => {
                listDetails.value = res.data;
                Object.assign(form, { details: res.data })
            }).catch(({ response }) => {
                errManager(response);
            }).finally(() => {
                loading.value = false;
            });
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            const valid = await formEl.validate();
            if(!valid) return;

            const hasData = props.itemOrder && Object.keys(props.itemOrder).length > 0;
            if(hasData)
                onUpdate();
            else 
                onSave();
        };

        const getSummaries = (param: { columns: any[]; data: any[] }) => {
            const { columns, data } = param
            const sums: (string | number)[] = []

            columns.forEach((column, index) => {
                if (index === 0) {
                sums[index] = 'Total'
                return
                }
                if (index === 4) { // 👈 quinta columna (empieza en 0)
                const total = data.reduce((sum, row) => {
                    const value = parseFloat(row.price) || 0   // 🔥 forzamos a número
                    return sum + value
                }, 0);
                sums[index] = total.toFixed(2)
                } else {
                sums[index] = ''
                }
            })

            return sums
        }

        const deleteItemDetails = async(row: any) => {
            if(props.itemOrder){
                loading.value = true;
                await GlobalService.delete(`orders/${props.itemOrder?.idorder}/delete`, `${row.iddetails}/details`)
                .then((res)=>{
                    loading.value = false;
                    if (res.data.status == 'success') getOrderDetails();
                    showNotification({title: res.data.title, message: res.data.message, status: res.data.status});
                }).catch(({response})=>{
                    loading.value=false;
                    errManager(response);
                });
            } else {
                listDetails.value = listDetails.value.filter(
                    (item) => item.idregister !== row.idregister
                );
                Object.assign(form, { details: listDetails.value })
                emit("deleteItemOrderDetail", row.idregister);
            }
        }

        const onRepeat = (data: any) => {
            loading.value = false;
                showNotification(data);
                if(data.status == 'success') {
                    isModalVisible.value = false;
                    emit("onResponseOrderDetails", data);
                }
        }

        const onUpdate = async() => {
            loading.value = true;
            await GlobalService.update('orders', form.idorder, 'update', form)
            .then((res)=>{
                onRepeat(res.data)
            }).catch(({response})=>{
                loading.value=false;
                errManager(response);
            })
        };

        const onSave = async() => {
            if(form.details.length<=0){
                showNotification({title: 'Alerta', message: 'Detalle no puede estar vacio', status:'error'});
                return;
            }
            loading.value = true;
            form.idregister = props.otherData?.idregister;
            form.idcountry = props.otherData?.idcountry;
            await GlobalService.post('orders/save', form)
            .then((res)=>{
                loading.value = false;
                if(res.data.status == 'success'){     
                    Swal.fire({
                        icon: res.data?.status,
                        title: res.data?.title,
                        html: res.data?.message,
                        confirmButtonText: 'Entendido',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            emit("onResponseOrderDetails", res.data);
                            isModalVisible.value = false;
                        } else if (result.isDismissed) {
                            //console.log('El usuario canceló o cerró el modal')
                        }
                    })
                } else {
                    showNotification(res.data);
                }
            }).catch(({response})=>{
                loading.value=false;
                errManager(response);
            })
        };

        const editItem = (data: any, index: number) => {
            if(DialogEditItemDetailRef.value){
                itemDetails.value = data
                itemDetails.value.indice = index;
                DialogEditItemDetailRef.value.openModal();
            }
        }

        const onUpdateItemOrderDetails = (data: any) => {
            listDetails.value[data.indice] = {
                ...listDetails.value[data.indice], // mantiene los valores anteriores
                ...data                   // reemplaza solo lo que envías
                }
        }

        return{
            t,
            loading,
            titleDialog,
            isModalVisible,
            form,
            rules,
            ruleFormRef,
            listComprobantes,
            listPaymentMethods,
            listPaymentCurrencies,
            listDetails,
            listStatus,
            userAccount,
            DialogEditItemDetailRef,
            itemDetails,
            //event
            openModal,
            onOpen,
            onClosed,
            submitForm,
            getSummaries,
            deleteItemDetails,
            onUpdate,
            editItem,
            onUpdateItemOrderDetails
            

        }
    },
})
